import { Container, Dialog, DialogContent, DialogTitle, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import InputBase from '@mui/material/InputBase';
import { makeStyles } from 'tss-react/mui';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil';
import { selectedDps } from '../../../atoms/DspState';
import { AxlButton } from '../../../components/AxlButton';
import Delete from '../../../components/Dialog/Delete';
import ListHeader from '../../../components/ListHeader';
import Pagination from '../../../components/Pagination';
import { APPROVE_DRIVER_SUCCESS, driverAtom, driverSelector, existedDriversState, LOADED_LIST_DRIVER, LOADING_LIST_DRIVER, REMOVE_DRIVER_SUCCESS } from '../../../reducers/DriverReducer';
import { dspSelector, UPDATE_TOTAL_DRIVER_DSP_LIST } from '../../../reducers/DspReducer';
import { listDspDriver, manuallyApprove, removeDriver, updatePassword } from '../../../repositories/HttpRepository';
import ActionButton from './ActionButton';
import ConvertDriverButton from './ConvertDriverButton';
import ResetPassword from './ResetPassword';

const fields = [
  {
    id: 'id',
    label: 'id',
  },
  {
    id: 'name',
    label: 'Name',
  },
  {
    id: 'username',
    label: 'Username',
  },
  {
    id: 'email',
    label: 'Email',
  },
  {
    id: 'phone_number',
    label: 'Phone Number',
  },
  // {
  //   id: 'signed',
  //   label: 'Signed',
  // },
  {
    id: 'status',
    label: 'Status',
  },
  {
    id: 'background_status',
    label: 'Background Status',
  },
  {
    id: 'action',
    label: 'Action',
    isDisableSort: true,
  },
];

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
  },
  form: {
    display: 'flex',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    border: '1px solid #e0e0eb',
  },
  table: {
    minWidth: 750,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(2),
    marginBottom: '10px',
    '& button': {
      height: '35px',
    },
  },
  button: {
    // TODO WILL REMOVE
    padding: '8px 15px',
  },
  dialogTitle: {
    paddingLeft: 0,
    '& h2': {
      fontWeight: 700,
    },
  },
  addBtn: {
    backgroundColor: '#75c31e',
  },
  basicInfo: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '10px',
  },
  closeBtn: {
    position: 'absolute',
    right: 40,
    top: 15,
    color: '#d8d8d8',
    fontSize: 44,
    cursor: 'pointer',
  },
  search: {
    '& form': {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2),
    },
  },
}));
const ListDriver = () => {
  const [state, updateValueDriver] = useRecoilState(driverSelector);
  const resetDriverAtom = useResetRecoilState(driverAtom);
  const updateValuesDsp = useSetRecoilState(dspSelector);
  const [openPopupRemove, setOpenPopupRemove] = useState(false);
  const [openPopupApprove, setOpenPopupApprove] = useState(false);
  const [openPopupResetPassword, setOpenPopupResetPassword] = useState(false);
  const [approveDriverId, setApproveDriverId] = useState(null);
  const navigate = useNavigate();
  const { items, page, size, desc, order_by, total, isListing } = state;
  const { classes } = useStyles();
  const { courierId } = useParams();
  const [selectedDriver, setSelectedDriver] = useState({
    id: null,
    name: null,
    username: null,
    user_id: null,
  });
  const selectedDsp = useRecoilValue(selectedDps);
  const [existedDriverIds, setExistedDriverIds] = useRecoilState(existedDriversState);
  const [keyword, setKeyword] = useState('');

  const getList = (params) => {
    let queryParams = { page, size };
    if (params) queryParams = { ...queryParams, ...params };

    updateValueDriver({ type: LOADING_LIST_DRIVER });
    listDspDriver(queryParams, courierId).then((resp) => {
      if (resp.ok) {
        updateValueDriver({
          type: LOADED_LIST_DRIVER,
          data: resp.data,
          params: queryParams,
        });
        let existedIds = resp.data.items.map((obj) => {
          return obj.id;
        });
        setExistedDriverIds(existedIds);
      }
    });
  };
  useEffect(() => {
    getList();
  }, [total]);
  const handleRequestSort = (event, property) => {
    const isDesc = order_by === property && desc;
    getList({ page, order_by: property, desc: !isDesc });
  };

  const handleChangePage = (event, newPage) => {
    getList({ page: newPage - 1, order_by, desc });
  };
  const addAction = (e) => {
    e.preventDefault();
    navigate(`/dsp/drivers/${courierId}/add`);
  };
  // no-dd-sa:javascript-code-style/max-params
  const removeDriverInList = (e, driverId, driverName, username, userID) => {
    e.preventDefault();
    setOpenPopupRemove(true);
    setSelectedDriver({
      id: driverId,
      name: driverName,
      username: username,
      user_id: userID,
    });
  };

  function handleRemoveAccept() {
    removeDriver(courierId, selectedDriver.id).then((resp) => {
      if (resp.ok) {
        updateValueDriver({
          type: REMOVE_DRIVER_SUCCESS,
          payload: selectedDriver.id,
        });
        updateValuesDsp({
          type: UPDATE_TOTAL_DRIVER_DSP_LIST,
          payload: { courierId, isAdded: false },
        });
        toast.success('Remove successfully');
        setOpenPopupRemove(false);
      } else {
        toast.error(resp?.data?.message ?? 'Something went wrong!');
      }
    });
  }
  const handleClosePopup = () => {
    setOpenPopupApprove(false);
  };
  // no-dd-sa:javascript-code-style/max-params
  const handleOpenPopup = (e, id, driverName, username, userId) => {
    e.preventDefault();
    setApproveDriverId(id);
    setOpenPopupApprove(true);
    setSelectedDriver({
      id: id,
      name: driverName,
      username: username,
      user_id: userId,
    });
  };
  const approveAction = () => {
    manuallyApprove(approveDriverId).then((rsp) => {
      if (rsp.ok) {
        updateValueDriver({
          type: APPROVE_DRIVER_SUCCESS,
          payload: approveDriverId,
        });
        setOpenPopupApprove(false);
        toast.success('Approve successfully');
        setApproveDriverId(null);
      }
    });
  };

  // no-dd-sa:javascript-code-style/max-params
  function handleResetPassword(e, id, name, username, phoneNumber, userId) {
    setSelectedDriver({
      id: id,
      name: name,
      username: username,
      phoneNumber: phoneNumber,
      user_id: userId,
    });
    setOpenPopupResetPassword(true);
  }

  function handleApproveResetPassword(username, newPassword, sendSms) {
    updatePassword(selectedDriver.user_id, {
      username: username,
      new_password: newPassword,
      new_password1: newPassword,
      send_sms: sendSms,
    }).then((resp) => {
      if (resp.ok) {
        toast.success('Password updated successfully');
        setOpenPopupResetPassword(false);
      }
    });
  }

  function handleCancel() {
    resetDriverAtom();
    window.setTimeout(() => {
      navigate('/dsp');
    }, 10);
  }

  const doSearchDriver = (e) => {
    e.preventDefault();
    let queryParams = { page, size };
    queryParams = { ...queryParams, q: keyword };
    // console.log(queryParams);
    updateValueDriver({ type: LOADING_LIST_DRIVER });
    listDspDriver(queryParams, courierId).then((resp) => {
      if (resp.ok) {
        updateValueDriver({
          type: LOADED_LIST_DRIVER,
          data: resp.data,
          params: queryParams,
        });
        let existedIds = resp.data.items.map((obj) => {
          return obj.id;
        });
        setExistedDriverIds(existedIds);
      }
    });
    return false;
  };

  return (
    <>
      <Dialog
        fullWidth
        maxWidth={false}
        open
        onClose={() => {
          navigate('/dsp');
        }}
      >
        <DialogContent>
          <Container maxWidth={false}>
            <DialogTitle id="form-dialog-title" className={classes.dialogTitle}>
              Drivers’ List
            </DialogTitle>
            <CloseIcon className={classes.closeBtn} onClick={handleCancel} />
            <div className={classes.basicInfo}>
              <div>
                <p>
                  Company name: <strong>{selectedDsp.company}</strong>
                </p>
                <p>
                  Total drivers: <strong>{total}</strong>
                </p>
              </div>
              <div className={classes.buttonWrapper}>
                <AxlButton variant="contained" color="primary" onClick={addAction} className={classes.addBtn}>
                  ADD DRIVER
                </AxlButton>
              </div>
            </div>
            <Paper component="div" className={classes.search}>
              <form onSubmit={doSearchDriver}>
                <InputBase
                  fullWidth
                  onChange={(e) => setKeyword(e.target.value)}
                  className={classes.input}
                  placeholder="Search by ID, Username, Email ..."
                  inputProps={{ 'aria-label': 'Search by ID, Username, Email' }}
                  style={{ padding: '10px' }}
                />
                <IconButton type="submit" className={classes.iconButton} aria-label="search" size="large">
                  <SearchIcon />
                </IconButton>
              </form>
            </Paper>

            <Paper elevation={0} className={classes.paper}>
              <TableContainer>
                <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
                  <ListHeader fields={fields} desc={desc} orderBy={order_by} onRequestOrder={handleRequestSort} rowCount={items.length} />
                  <TableBody>
                    {items.map((item, index) => {
                      if (!item) {
                        return;
                      }

                      const labelId = `driver-table-item-${index}`;

                      return (
                        <TableRow hover tabIndex={-1} key={`driver-${item.id}`}>
                          <TableCell component="th" id={labelId} scope="row">
                            {item.id}
                          </TableCell>
                          <TableCell>
                            {item.first_name} {item.last_name}
                          </TableCell>
                          <TableCell>{item.username}</TableCell>
                          <TableCell>{item.email}</TableCell>
                          <TableCell>{item.phone_number}</TableCell>
                          {/* <TableCell>{item.signed}</TableCell> */}
                          <TableCell>{item.status}</TableCell>
                          <TableCell>{item.background_status}</TableCell>
                          <TableCell>
                            <ActionButton
                              bgStatus={item.background_status}
                              id={item.id}
                              name={item.first_name + item.last_name}
                              username={item.username}
                              userId={item.user_id}
                              phoneNumber={item.phone_number}
                              handleRemove={removeDriverInList}
                              handleApprove={handleOpenPopup}
                              handleResetPassword={handleResetPassword}
                            />
                            <ConvertDriverButton driver={item} onRefreshList={getList} />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
                {isListing && <LinearProgress />}
              </TableContainer>
              <Pagination total={total} size={size} onChange={handleChangePage} />
            </Paper>
          </Container>
        </DialogContent>
      </Dialog>
      {openPopupApprove && (
        <Delete
          labelCancel="NO"
          labelApprove="Yes, approve driver"
          content={'Are you sure to approve driver ' + selectedDriver.name + ' from ' + selectedDsp.company + ' ?'}
          handleCancel={(e) => setOpenPopupApprove(false)}
          handleApprove={() => approveAction()}
        ></Delete>
      )}
      {openPopupRemove && (
        <Delete
          labelCancel="NO"
          labelApprove="Yes, remove driver"
          content={'Are you sure to remove driver ' + selectedDriver.name + ' from ' + selectedDsp.company + ' ?'}
          handleCancel={(e) => setOpenPopupRemove(false)}
          handleApprove={() => handleRemoveAccept()}
        ></Delete>
      )}
      {openPopupResetPassword && <ResetPassword handleCancel={(e) => setOpenPopupResetPassword(false)} handleApprove={handleApproveResetPassword} infos={selectedDriver} />}
    </>
  );
};
export default React.memo(ListDriver);
